import { useEffect, useState } from "react";
import { HardDrive } from "lucide-react";
import { api } from "@/lib/api";

export function StorageMeter({ hubId, compact = false }) {
  const [u, setU] = useState(null);
  useEffect(() => { api.get(`/organizations/${hubId}/storage`).then(({ data }) => setU(data)).catch(() => {}); }, [hubId]);
  if (!u) return null;
  const pct = Math.min(100, u.percent);
  const rgb = pct >= 100 ? "var(--glow-media)" : pct >= 80 ? "var(--glow-lists)" : "var(--glow-family)";
  return (
    <div className={compact ? "mb-4" : ""} data-testid="storage-meter">
      <div className="flex items-center gap-2 text-sm font-semibold text-q-text"><HardDrive className="h-4 w-4" style={{ color: `rgb(${rgb})` }} /><span data-testid="storage-label">{u.label}</span></div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-q-raised" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="h-full rounded-full transition-[width] duration-300" style={{ width: `${pct}%`, background: `rgb(${rgb})` }} />
      </div>
      {!compact && u.by_category.length > 0 && (
        <ul className="mt-3 space-y-1 text-sm" data-testid="storage-breakdown">
          {u.by_category.map((c) => <li key={c.category} className="flex justify-between gap-2 text-q-muted" data-testid={`storage-cat-${c.category}`}><span>{c.category}</span><span className="text-q-text">{c.label}</span></li>)}
        </ul>
      )}
    </div>
  );
}

export default function Storage({ hub }) {
  return (
    <section id="storage" className="q-card mt-6" data-testid="settings-storage">
      <h2 className="font-display text-lg font-bold text-q-text">Storage</h2>
      <p className="mb-3 mt-1 text-sm text-q-muted">One shared allowance for Documents and Home care files. Photos are compressed automatically.</p>
      <StorageMeter hubId={hub.id} />
    </section>
  );
}
